<!-- metric-table.component.html -->
<div class='dynamic-tasks-container'>
  <div class='header-line' fxLayout fxLayoutAlign='space-between center' fxLayoutGap='4px'>
    <div fxLayout fxLayoutAlign='start center' fxLayoutGap='4px'>
      <ng-template #descriptionTemplate>
        <div class="description-template" [innerHTML]="formatInnerText(cardDescription | linkify)"></div>
      </ng-template>

      <div class='table-title'>{{ cardTitle }}</div>

      <mat-icon
        [matTooltip]="'OPEN_DESCRIPTION' | translate"
        [matTooltipPosition]="'above'"
        (click)='openDescription(descriptionTemplate)'
      >info</mat-icon>
    </div>

    <div fxLayout fxLayoutAlign='end center'>
      <mat-icon
        [style]="isRefreshing || isLoading ? 'color: rgba(0, 0, 0, 0.5411764706)' : 'color: black'"
        style="cursor: pointer"
        (click)="$event.stopPropagation(); refreshTable()"
      >refresh</mat-icon>
    </div>
  </div>

  <div class="progress-bar-wrapper">
    <mat-progress-bar *ngIf="isLoading" [mode]="'indeterminate'"></mat-progress-bar>
  </div>

  <table mat-table [dataSource]='tableData' class='mat-elevation-z0' matSort>
    <!-- Manager Column -->
    <ng-container matColumnDef='manager'>
      <th mat-header-cell *matHeaderCellDef>{{ 'MANAGER' | translate }}</th>
      <td mat-cell *matCellDef='let element'>
        <app-popup-select-complete
          [selected]='element.completedBy'
          [addAvailable]='!element.completedBy?.length'
          [removeAvailable]='false'
          (click)="$event.stopPropagation()"
        ></app-popup-select-complete>
      </td>
    </ng-container>

    <!-- Planned Date Column -->
    <ng-container matColumnDef="planned_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="date">{{ 'PLANNED_DATE' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        <app-custom-date-picker
          [initValue]="element.date"
          [bcColor]="getOverdueStatusColor(element.date)"
          (valueChange)="onDateChange($event, element)"
        ></app-custom-date-picker>
      </td>
    </ng-container>

    <!-- Next Action Date Column (column id next_action_date for backend displayColumns) -->
    <ng-container matColumnDef="next_action_date">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="nextActionDate">{{ 'NEXT_ACTION_DATE' | translate }}</th>
      <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
        <app-custom-date-picker
          [initValue]="element.nextActionDate"
          [bcColor]="element.nextActionDate ? getOverdueStatusColor(element.nextActionDate) : null"
          (valueChange)="onNextActionDateChange($event, element)"
        ></app-custom-date-picker>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef='status'>
      <th mat-header-cell *matHeaderCellDef>{{ 'STATUS' | translate }}</th>
      <td mat-cell *matCellDef='let element'>
        <app-task-status-pill
          [task]='element'
          (statusChange)='onStatusChange($event, element)'
          (click)="$event.stopPropagation()"
        ></app-task-status-pill>
      </td>
    </ng-container>

    <!-- Description Column -->
    <ng-container matColumnDef='description'>
      <th mat-header-cell *matHeaderCellDef>{{ 'DESCRIPTION' | translate }}</th>
      <td mat-cell *matCellDef='let element' [innerHTML]="prepareCommentValue(element.comment)"></td>
    </ng-container>

    <!-- Meeting Goal Column -->
    <ng-container matColumnDef='meeting_goal'>
      <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_GOAL' | translate }}</th>
      <td mat-cell *matCellDef='let element'>{{ customValuesDict[element.id]?.meeting_goal }}</td>
    </ng-container>

    <!-- Meeting Reason Column -->
    <ng-container matColumnDef='meeting_reason'>
      <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_REASON' | translate }}</th>
      <td mat-cell *matCellDef='let element'>{{ customValuesDict[element.id]?.meeting_reason }}</td>
    </ng-container>

    <!-- Meeting Result Column -->
    <ng-container matColumnDef='meeting_result'>
      <th mat-header-cell *matHeaderCellDef>{{ 'MEETING_RESULT' | translate }}</th>
      <td mat-cell *matCellDef='let element'>{{ customValuesDict[element.id]?.meeting_result }}</td>
    </ng-container>

    <!-- Order Column -->
    <ng-container matColumnDef='orders'>
      <th mat-header-cell *matHeaderCellDef>{{ 'ORDER.ORDER' | translate }}</th>
      <td mat-cell *matCellDef='let element'>
        <a *ngIf="element.order?.id" [routerLink]="'/orders/edit/' + parseGlobalId(element.order?.id)" target="_blank">
          {{ parseGlobalId(element.order?.id) }}
        </a>
        <div>{{ element.order?.specification?.positionTitle }}</div>
      </td>
    </ng-container>

    <!-- Next Action Column -->
    <ng-container matColumnDef='next_action'>
      <th mat-header-cell *matHeaderCellDef>{{ 'NEXT_ACTION' | translate }}</th>
      <td mat-cell *matCellDef='let element'>{{ element.nextActionCategory?.title }}
      </td>
    </ng-container>

    <!-- Metric Column -->
    <ng-container matColumnDef='metric_value'>
      <th mat-header-cell *matHeaderCellDef>{{ 'METRIC' | translate }}</th>
      <td mat-cell *matCellDef='let element'>{{ getCurrentMetricValue(element)?.metricGroup.title }}</td>
    </ng-container>

    <!-- Reason/Comment Column -->
    <ng-container matColumnDef='reasons_with_comments'>
      <th mat-header-cell *matHeaderCellDef>{{ 'REASON_WITH_COMMENT' | translate }}</th>
      <td mat-cell *matCellDef='let element'>
        <div class='reasons-container'>
          <app-reason-with-comment
            *ngFor='let reason of element.reasonSet'
            [reason]='reason'
            [managerName]='getCurrentMetricValue(element)?.manager?.fullName'
            [metricValueCandidate]="{ firstName: getCurrentMetricValue(element)?.candidate?.firstName,
                                      lastName: getCurrentMetricValue(element)?.candidate?.lastName,
                                      livasId: getCurrentMetricValue(element)?.candidate?.livasId,
                                      employeeLivasId: getCurrentMetricValue(element)?.candidate?.employeeLivasId }"
            [metricValueClient]="{ name: getCurrentMetricValue(element)?.client?.name || '',
                                   id: getCurrentMetricValue(element)?.client?.id }"
            [metricGroup]='getCurrentMetricValue(element)?.metricGroup?.title'
            [metricGroupId]='getCurrentMetricValue(element)?.metricGroup?.id'
            (updateCommentsValue)="loadTasks()"
          ></app-reason-with-comment>
        </div>
      </td>
    </ng-container>

    <!-- Metric Date Column -->
    <ng-container matColumnDef='metricDate'>
      <th mat-header-cell *matHeaderCellDef>{{ 'METRIC_DATE' | translate }}</th>
      <td mat-cell *matCellDef='let element'>{{ getCurrentMetricValue(element)?.date }}</td>
    </ng-container>

    <!-- Client Column -->
    <ng-container matColumnDef='client'>
      <th mat-header-cell *matHeaderCellDef>{{ 'CLIENT.CLIENT' | translate }}</th>
      <td mat-cell *matCellDef='let element'>{{ element.company?.name }}</td>
    </ng-container>

    <!-- Candidate Column -->
    <ng-container matColumnDef='candidate'>
      <th mat-header-cell *matHeaderCellDef>{{ 'CANDIDATE' | translate }}</th>
      <td mat-cell *matCellDef='let element'>{{ element.candidate?.firstName }} {{ element.candidate?.lastName }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef='displayedColumns'></tr>
    <tr mat-row *matRowDef='let row; columns: displayedColumns;' (click)='openTaskDialog(row)'></tr>
  </table>
</div>
